import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRstudioComponent } from './simple-icons-rstudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRstudioComponent ],
    exports:      [ SimpleIconsRstudioComponent ],
    bootstrap:    []
})
export class SimpleIconsRstudioModule {}
